module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "admissions-hero-2.4aed21ec.jpeg" + "?" + Date.now();